import { TableCell, TableRow } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";
import type { ComponentProps } from "react";

export const WorkspaceTableRowSkeleton = () => {
  return (
    <TableRow>
      <TableCell className="w-[13%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[65%]" />
        </div>
      </TableCell>
      <TableCell className="w-[13%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[25%]" />
        </div>
      </TableCell>
      <TableCell className="w-[19%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[75%]" />
        </div>
      </TableCell>
      <TableCell className="w-[19%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[60%]" />
        </div>
      </TableCell>
      <TableCell className="w-[26%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="size-6 rounded-full mr-2" />
          <Skeleton className="h-4 w-[60%]" />
        </div>
      </TableCell>
      <TableCell className="w-[10%]">
        <div className="min-h-12 flex items-center">
          <div className="flex items-center">
            <Skeleton
              className="size-6 rounded-full relative"
              style={
                {
                  boxShadow: `
                  0 0 0 2px white,
                  12px 0 0 0 var(--skeleton-shadow-color),
                  12px 0 0 2px white,
                  24px 0 0 0 var(--skeleton-shadow-color),
                  24px 0 0 2px white,
                  35px 0 0 -0.5px var(--skeleton-shadow-color),
                  35px 0 0 1.5px white
                `,
                } as ComponentProps<typeof Skeleton>["style"]
              }
            />
          </div>
        </div>
      </TableCell>
    </TableRow>
  );
};
